import { AIValidationResult } from "src/hooks/useDocumentAI";

/**
 * Get the preferred value from AI results for display.
 * Uses normalized_value for best UX (properly formatted dates/numbers),
 * with fallback to raw matching_value if normalization failed.
 */
export const getPreferredValue = (aiSuggestion: AIValidationResult): string => {
  // Prefer normalized_value for the best user experience (properly formatted dates/numbers)
  if (
    aiSuggestion.normalized_value &&
    aiSuggestion.normalized_value !== "None"
  ) {
    return aiSuggestion.normalized_value.trim();
  }

  // Fall back to raw matching_value if normalization failed
  return aiSuggestion.matching_value?.trim() || "";
};
